gsap.registerPlugin(ScrollTrigger)


//HOME ANIMATIONS

if (jQuery('body').hasClass('template-index')) {

    let container = document.getElementById("container");

    if(container){
      gsap.to(container, {
          x: () => `${-(container.scrollWidth - document.documentElement.clientWidth)}px`,
          ease: "none",
          scrollTrigger: {
              trigger: container,
              invalidateOnRefresh: true,
              pin: true,
              scrub: 0.2,
              start: "top top",
              end: () => `+=${container.scrollWidth - document.documentElement.clientWidth}`
          }
      });
    }
    

    window.addEventListener("load", function () {
        const scrollColorElems = document.querySelectorAll(".horizontal-container .module");
        scrollColorElems.forEach((colorSection, i) => {

        });


        var horizontalWidth = jQuery('.horizontal-container').outerWidth();
        var horizontalWidthMultiplied = horizontalWidth * 2;

        //console.log(horizontalWidthMultiplied);

        const myTimeline = gsap.timeline({

            scrollTrigger: {
                trigger: ".horizontal-container",
                pin: false,
                scrub: true,
                start: "top",
                end: () => `+=${horizontalWidthMultiplied}`
            }

        })

        /*myTimeline
            .to('.home-featured-product', {
                duration: 1,
                backgroundColor: '#006450',
                ease: "none"
            }, 0)
            .to('.home-featured-product', {
                duration: 1,
                backgroundColor: '#cd0e0f',
                ease: "none"
            }, 1)
            .to('.lettering-container p', {
                duration: 1,
                color: '#FCDC3E',
                ease: "none"
            }, 0)
            .to('.lettering-container p', {
                duration: 1,
                color: '#de9f0d',
                ease: "none"
            }, 1)
*/

        // HOME SMOKY PACKET
        var rotate = gsap.timeline({
            scrollTrigger: {
                trigger: ".home-featured-product",
                scrub: 0.5,
                start: 'top top +=200',
                end: '+=10000',
            }
        })
            .to('.home-featured-product.pro-1 .content-container img', {
                rotation: -360 * 5,
                duration: 1,
                ease: 'none',
            })


        gsap.set('.home-featured-product.pro-2 .content-container img', {
            rotate: -300
        });

        gsap.set('.home-featured-product.pro-3 .content-container img', {
            rotate: 300
        });


        homeCheeseDesktop()

        jQuery(window).resize(function () {
            homeCheeseDesktop()
        });

        function homeCheeseDesktop() {

            var superrotate = gsap.timeline({
                scrollTrigger: {
                    trigger: "main",
                    scrub: 0.2,
                    start: 'top top',
                    end: '+=10000',
                }
            })
                .to('.home-featured-product.pro-3 .content-container img', {
                    rotation: 360 * 7,
                    ease: 'none',
                })

            if (jQuery(window).width() > 900) {
                // HOME CHEESE PACKET
                var rotate = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".home-featured-product",
                        scrub: 0.5,
                        start: "bottom +25%",
                        end: "bottom 0%",
                    }
                })
                    .to('.home-featured-product.pro-2 .content-container img', {
                        rotation: -360,
                        duration: 1,
                        ease: 'none',
                    })
            }
            if ((jQuery(window).width() < 900) && (jQuery(window).width() > 767)) {
                // HOME CHEESE PACKET
                var rotate = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".home-featured-product",
                        scrub: 0.5,
                        start: "bottom +55%",
                        end: "bottom +200",
                    }
                })
                    .to('.home-featured-product.pro-2 .content-container img', {
                        rotation: -360,
                        duration: 1,
                        ease: 'none',
                    })
            }
            if ((jQuery(window).width() < 768) && (jQuery(window).width() > 100)) {
                // HOME CHEESE PACKET
                var rotate = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".home-featured-product",
                        scrub: 0.5,
                        start: "bottom +75%",
                        end: "bottom +400",
                    }
                })
                    .to('.home-featured-product.pro-2 .content-container img', {
                        rotation: -360,
                        duration: 1,
                        ease: 'none',
                    })
            }
        }
    });
  
    

  
}